/**
 * Web Style Import
 *
 */

import './style/dnb-number-format.scss'
